import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { CreditCard, Calendar } from 'lucide-react';

/**
 * Provider-org context view: read-only billing summary for a linked org.
 * Returned early by BillingTab when the user is viewing an org-scoped page.
 */
export default function OrgScopedBillingView({ activeOrg, orgBilling }) {
  return (
    <div className="space-y-6" data-testid="org-billing-view">
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-1">{activeOrg?.name || 'Organization'} — Billing</h2>
        <p className="text-sm text-gray-500">Billing information for this linked organization.</p>
      </div>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="p-2 rounded-lg bg-teal-100">
              <CreditCard className="w-5 h-5 text-teal-700" />
            </div>
            <div>
              <p className="text-lg font-bold text-gray-900">Billed to Provider</p>
              <p className="text-sm text-gray-500">This organization's usage is included in your Provider plan.</p>
            </div>
          </div>
          {orgBilling.linked_at && (
            <div className="bg-teal-50 border border-teal-200 rounded-lg p-3 text-sm text-teal-800">
              <Calendar className="w-4 h-4 inline mr-2" />
              Billed to Provider from <strong>{new Date(orgBilling.linked_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</strong>
            </div>
          )}
        </CardContent>
      </Card>
      {orgBilling.previous_billing?.was_billed && (
        <Card>
          <CardHeader>
            <CardTitle className="text-base text-gray-700">Previous Billing (Read-Only)</CardTitle>
            <CardDescription>This organization was previously billed directly before joining your network.</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 gap-4 text-sm">
              <div>
                <p className="text-gray-500">Previous Plan</p>
                <p className="font-medium text-gray-900 capitalize">{orgBilling.previous_billing.plan || 'Solo'}</p>
              </div>
              <div>
                <p className="text-gray-500">Previous Status</p>
                <p className="font-medium text-gray-900 capitalize">{orgBilling.previous_billing.status || 'Unknown'}</p>
              </div>
              {orgBilling.previous_billing.saved_at && (
                <div className="col-span-2">
                  <p className="text-gray-500">Billing Transferred On</p>
                  <p className="font-medium text-gray-900">{new Date(orgBilling.previous_billing.saved_at).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}</p>
                </div>
              )}
            </div>
            <p className="text-xs text-gray-400 mt-3">Any remaining balance was prorated at the time of transfer.</p>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
